// extracted by mini-css-extract-plugin
export default {"container":"styles_container__u+GZ6","card":"styles_card__-Awn4"};